<template>
  <div>
    <div class="admin_title">考试中心</div>
    <!--右侧内容-->
    <div class="gj_top_class">
      <input name="" type="button" class="btn_s_gj" @click="searchByFilter(filter)"/><input name="" type="text" class="put_gj" v-model="filter.title" @keyup.13="searchByFilter(filter)"/>
      <select v-model="filter.isPublish" @change="searchByFilter(filter)">
        <option value="">全部(公开状态)</option>
        <option value="1">已上架</option>
        <option value="0">已下架</option>
      </select>
      <select v-model="filter.largeType" @change="getMiddleTypes(filter.largeType)">
        <option :value="''">(全部)大分类</option>
        <option v-for='item in largeTypes' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select v-model="filter.middleType" @change="searchByFilter(filter)">
        <option :value="''">(全部)小分类</option>
        <option v-for='item in middleTypes' :key="item.middleType" :value="item.middleType">{{item.middleTypeLabel}}</option>
      </select>
      <select name="level" v-model="filter.level" @change="searchByFilter(filter)">
        <option value="">全部(等级)</option>
        <option v-for='item in Dropdown.state.level' :key="item.value" :value="item.value">{{item.label}}</option>
      </select>
      <select name="level" v-model="filter.type" @change="searchByFilter(filter)">
        <option :value="'1'">试卷</option>
        <option :value="'0'">题组</option>
      </select>
      <a href="javascript:;" @click="editExamPaper('')">新增试卷</a>
    </div>
    <div class="training_list_manage">
      <!--计划列表-->
      <dl v-if="cnt>0" v-for="item in list" :key="item.id">
        <dt style="position: relative;">
          <span class="enroll_badge" style="position: absolute; top: -12px; z-index: 12;">{{item.isPublish=='1' ? '已上架' : '已下架'}}</span>
          <div class="exam_img">
            <img :src="item.faceUri" width="220px" height="118px" v-if="item.faceUri && item.faceUri!=''">
            <img src="@/assets/images/test_img.jpg"  width="220px" height="118px" v-if="!item.faceUri || item.faceUri==''">
            <h3 v-if="item.type=='1'" class="examH3">考试时间: <span v-if="item.startDate">{{$utils.substring(item.startDate,0,10)}}</span>至 <span v-if="item.endDate">{{$utils.substring(item.endDate,0,10)}}</span></h3>
          </div>

          <div class="col_2_1 exam_div"><span>{{item.title}}</span><span class="red_font font12" v-if="judgmentState(item.startDate, item.endDate) === 'over' && item.type=='1'">已结束</span><span class="red_font font12" v-if="judgmentState(item.startDate, item.endDate) === 'willStart' && item.type=='1'">未开始</span><span class="red_font font12" v-if="judgmentState(item.startDate, item.endDate) === 'start' && item.type=='1'">进行中</span></div>

        </dt>
        <dd class="exam_div_two">
          <a href="javascript:;" class="col_2_1" @click="examPaperScore(item.id)" v-if="item.isUsed!='0'">参与人次：{{item.isUsed}}次 ></a>
          <a href="javascript:;" class="col_2_1" v-if="item.isUsed=='0'">参与人次：0次 ></a>
          <ul class="col_2_2 total-scope-train">
            <p><img src="@/assets/images/exam_manage_icon_down.png" alt=""></p>
            <li class="total-scope-tan" style="display: none;">
              <a class="topA" @click="editExamPaper(item.id)" v-if="item.isUsed!='0'">查看</a>
              <a class="topB" :class="{'topA':item.isUsed=='0', 'topB': item.isUsed!='0'}" @click="editExamPaper(item.id)" v-if="item.isUsed=='0'">编辑</a>
              <a class="topB" :class="{'topB':item.isUsed=='0', 'topB': item.isUsed!='0'}" @click="delExamPaper(item.id)" v-if="item.isUsed=='0'">删除</a>
              <a class="topB" @click="examPaperScore(item.id)" v-if="item.isUsed!='0'">成绩一览</a>
              <a class="topC" @click="copyExam(item.id)">复制</a>
            </li>
          </ul>
          <div class="clear"></div>
        </dd>
      </dl>
      <h5 class="none_ts" v-if="cnt <= 0">
        <img src="@/assets/images/none_data.jpg" alt="">
      </h5>
    </div>
    <!--/右侧内容-->
    <div class="clear"></div>
    <div class="zy_list_bottom" v-if="cnt>0">
      <dl>
        <dt><!--<input id="sel_1" onchange="selectAll()" type="checkbox" value="1" style="opacity: 1;"/> 全选 <input name="" type="button" value="批量上架" class="btn_zy_bottom" /> <input name="" type="button" value="批量下架"  class="btn_zy_bottom"/> <input name="" type="button" value="删除所选"  class="btn_zy_bottom" />-->共{{cnt}}张考卷</dt>
        <dd>
          <paginate ref="paginate" :click-handler="clickCallback" :page-count=pages
                    :container-class=$global.paginationOptions.container_class :page-class=$global.paginationOptions.page_class :page-link-class=$global.paginationOptions.page_link_class
                    :prev-class=$global.paginationOptions.prev_class :prev-link-class=$global.paginationOptions.prev_link_class
                    :next-class=$global.paginationOptions.next_class :next-link-class=$global.paginationOptions.next_link_class
                    :first-last-button=$global.paginationOptions.first_last_button
                    :active-class=$global.paginationOptions.active_class
                    :disabled-class=$global.paginationOptions.disabled_class
                    :first-button-text=$global.paginationOptions.first_button_text
                    :last-button-text=$global.paginationOptions.last_button_text
                    :prev-text=$global.paginationOptions.prev_text
                    :next-text=$global.paginationOptions.next_text>
          </paginate>
        </dd>
      </dl>
    </div>
    <!--/右侧内容-->
  </div>
</template>
<script>
  import Dropdown from '@/store/modules/dropdowns'
  import Paginate from 'vuejs-paginate'
  import {init} from '@/assets/js/public'
  import s_query from '@/utils/s_query'
  import { getCookie } from '@/store/cookies'
  export default {
    components: { Paginate },
    data () {
      return {
        Dropdown: Dropdown,
        filter: {
          pageNo: 1,
          pageSize: this.$global.paginationOptions.page_num,
          largeType: '',
          level: '',
          middleType: '',
          title: '',
          type: '1',
          isPublish: ''
        },
        list: [],
        pages: 0,
        cnt: 0,
        largeTypes: [],
        middleTypes: [],
        timestamp: (new Date()).getTime(),
        prefix: this.$route.meta.prefix || ''
      }
    },
    created () {
      if (getCookie('query_record') && getCookie('query_record')[this.$route.path]) {
        this.filter = getCookie('query_record')[this.$route.path]
      }
      this.getExamPapers(this.filter)
      this.getLargeTypes()
    },
    mounted () {
      this.$on('data-prepared', function () {
        this.$nextTick(() => {
          init()
        })
      })
    },
    computed: {},
    methods: {
      clickCallback (pageNum) {
        this.filter.pageNo = pageNum
        this.getExamPapers(this.filter)
      },
      resetPagination () {
        this.filter.pageNo = 1
        if (this.$refs.paginate) {
          this.$refs.paginate.selected = 0 // 重置 active-class为第一页
        }
      },
      judgmentState (startDate, endDate) {
        let S_timestamp = this.$utils.transformDateStr(startDate)
        let E_timestamp = this.$utils.transformDateStr(endDate)
        if (this.timestamp >= S_timestamp && this.timestamp <= E_timestamp) {
          return 'start'
        } else if (this.timestamp > E_timestamp) {
          return 'over'
        } else if (this.timestamp < S_timestamp) {
          return 'willStart'
        }
      },
      getLargeTypes () {
        this.$api.post(this.$global.examApiPath, '/dict/get', {type: 'examPaperLargeType'}, r => {
          this.largeTypes = r.data
        })
      },
      getMiddleTypes (largeType) {
        this.$api.post(this.$global.examApiPath, '/examTypeRel/search', {largeType: largeType,  middleType: 'examPaperMiddleType', select: '1'}, r => {
          this.middleTypes = r.data
          this.searchByFilter(this.filter)
        })
      },
      searchByFilter (filter) {
        this.resetPagination()
        this.getExamPapers(filter)
      },
      getExamPapers (filter) {
        s_query.save(this.$route.path, filter)
        this.$api.post(this.$global.examApiPath, '/examPaper/search', filter, r => {
          this.cnt = r.cntData
          this.pages = Math.ceil(r.cntData / this.$global.paginationOptions.page_num)
          this.list = r.data
          this.$emit('data-prepared')
          this.$nextTick(() => { // 数据初始化时分页组件需要手动更新
            if (this.$refs.paginate) {
              this.$refs.paginate.selected = this.filter.pageNo - 1
            }
          })
        })
      },
      copyExam (id) {
        this.$api.post(this.$global.examApiPath, '/examPaper/copy', {id: id}, r => {
          this.getExamPapers(this.filter)
        })
      },
      editExamPaper (id) {
        if (id == '') {
          id = 'create'
        }
        this.$router.push({path: this.prefix + '/org/examPaper/'+ id})
      },
      delExamPaper (id) {
        this.$api.post(this.$global.examApiPath, '/examPaper/delete', {id: id}, r => {
          this.getExamPapers(this.filter)
        })
      },
      examPaperScore (id) {
        this.$router.push({path: this.prefix + '/org/examPaperScoreList/'+ id})
      }
    }
  }
</script>
<style lang="scss">
  .enroll_badge {
    background-color: #f56c6c;
    border-radius: 10px;
    color: #fff;
    display: inline-block;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
  }
</style>



// WEBPACK FOOTER //
// src/page/byl/org/examination_paper/list.vue